import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var listacentros=[];
var id="";
export default function  ParadaMap (props) {
    const [statelista, setalista]=React.useState([]);


   
             
    React.useEffect(() => {
        

        

                firebase.firestore().collection("centroadm").where('status', '==', true)
        .get()
        .then(function(querySnapshot) {
            listacentros=[];
            querySnapshot.forEach(function(doc) {
                listacentros.push({id: doc.id, label: doc.data().nomecentroadm});
            })
            setalista(listacentros)
            console.log("erro carregar as centros: ", listacentros);
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de transporte: ", error);
            alert('Não foi Possível carregar as unidades de transporte.');
        });
             
         
        
        
        

        

    },[props])

    const handleuniade=(event, value)=>(
        props.setanucleo(value)
    )

    return(
        <Autocomplete onChange={handleuniade}
        
                    id="combounidadetchef"
                    options={statelista}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params}  required={props.requer}  label="Núcleo Administrativo" variant="outlined" />}
                />
                
)
}